export default __webpack_public_path__ + "static/media/detail_big_12_2.9ffed653.jpg";